import { useContext, useState, Fragment } from 'react'
import { AppContext } from '../App'
import { Link } from 'react-router-dom'
import profileData from '../data/profile.json'

export const SidePanel = ({ isViewingIndexRoute }) => {
  const { isDesktopView } = useContext(AppContext)
  const [isDetailsExpanded, setIsDetailsExpanded] = useState(false)

  const { firstName, lastName, title, summary, content, contacts } =
    profileData.data

  return (
    <>
      {(isDesktopView || isViewingIndexRoute) && (
        <>
          <aside>
            <div>
              <Link to='/' className='icon_grid'>
                <span className='material-symbols-rounded'>home</span>
                <span>Home</span>
              </Link>
            </div>
            <section>
              <h1>
                {firstName} {lastName}
              </h1>
              <div className='info_container'>
                <h2>{title}</h2>
                <p>{summary}</p>
              </div>
              <div
                className='icon_grid caret'
                onClick={() => setIsDetailsExpanded(!isDetailsExpanded)}>
                <span
                  className={`material-symbols-rounded ${
                    isDetailsExpanded && 'caret-active'
                  }`}>
                  keyboard_arrow_right
                </span>
                <span>{isDetailsExpanded ? 'Less' : 'More'} details</span>
              </div>
              {(isDesktopView || isDetailsExpanded) && (
                <div className='info_container'>
                  {content.map((item, index) => (
                    <div className='icon_grid' key={index}>
                      <span className='material-symbols-rounded'>
                        {item.icon}
                      </span>
                      <span>{item.content}</span>
                      {item.info.map((infoItem, index) => (
                        <Fragment key={index}>
                          <div />
                          <span className='subtext'>{infoItem}</span>
                        </Fragment>
                      ))}
                    </div>
                  ))}
                </div>
              )}
            </section>
            <div className='info_container contacts'>
              {contacts.map((item, index) => {
                if (item.isHidden) return <Fragment key={index}></Fragment>
                return (
                  <a
                    href={item.url}
                    target='_blank'
                    rel='noopener noreferrer'
                    key={index}>
                    <img
                      src={item.src}
                      className={`${item.invertColour && 'svg-inverted'} ${
                        item.lightBackground && 'svg-bg_light'
                      }`}
                      alt={item.name}
                    />
                  </a>
                )
              })}
            </div>
          </aside>
        </>
      )}
    </>
  )
}
